<template>
  <div
    class="wt2-record-mouse-move"
    @click.capture="onClick"
    @mousedown="onMouseDown"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
    @mousemove="onMouseMove"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    reportMove: {
      type: Boolean,
      default: true,
    },

    reportMoveActiveOnly: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      mouseDown: false,
      mouseEnter: false,
      mouseMove: false,
      startPosition: {
        x: null,
        y: null,
      },
      movePosition: {
        x: null,
        y: null,
      },
    };
  },

  created() {
    document.addEventListener('mouseup', this.onMouseUp, false);
  },

  beforeDestroy() {
    document.removeEventListener('mouseup', this.onMouseUp, false);
  },

  watch: {
    movePosition: {
      handler(pos) {
        if (this.reportMove) {
          this.$emit('change', pos);
        }
      },
      deep: true,
    },
  },

  methods: {
    resetPositions() {
      this.movePosition = {
        x: null,
        y: null,
        diffX: null,
        diffY: null,
      };

      this.startPosition = {
        x: null,
        y: null,
      };
    },

    onMouseUp() {
      if (this.mouseDown && !this.mouseEnter) {
        this.mouseMove = false;
      }
      this.mouseDown = false;
      this.resetPositions();
    },

    onMouseDown(e) {
      this.mouseDown = true;
      this.startPosition.x = e.clientX;
      this.startPosition.y = e.clientY;
    },

    onMouseMove(e) {
      if (this.reportMoveActiveOnly && !this.mouseDown) {
        return;
      }

      // current diff
      this.movePosition.diffX = this.movePosition.x
        ? Math.abs(this.movePosition.x - e.clientX)
        : null;

      this.movePosition.diffY = this.movePosition.y
        ? Math.abs(this.movePosition.y - e.clientY)
        : null;

      if (this.movePosition.diffX || this.movePosition.diffY) {
        this.mouseMove = true;
      }

      // current positions
      this.movePosition.x = e.clientX;
      this.movePosition.y = e.clientY;
      // current movements
      this.movePosition.movementX = e.movementX;
      this.movePosition.movementY = e.movementY;
    },

    onMouseEnter() {
      this.mouseEnter = true;
    },

    onMouseLeave() {
      this.mouseEnter = false;
    },

    onClick(e) {
      if (this.mouseEnter && this.mouseMove) {
        this.mouseMove = false;
        e.preventDefault();
      }
    },
  },
};
</script>
